var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScissors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2851 9H17.7301C12.2701 9 9.01514 12.255 9.01514 17.715V30.27C9.01514 35.73 12.2701 38.985 17.7301 38.985H30.2851C35.7451 38.985 39.0001 35.73 39.0001 30.27V17.715C39.0001 12.255 35.7451 9 30.2851 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2548 23.9859L32.6548 19.9509C33.1498 19.5759 33.2548 18.8709 32.8798 18.3759C32.5048 17.8809 31.7998 17.7759 31.3048 18.1509L25.3798 22.5759L21.7798 19.8759C21.7948 19.7409 21.8248 19.6059 21.8248 19.4559C21.8248 17.5509 20.2798 16.0059 18.3748 16.0059C16.4698 16.0059 14.9248 17.5509 14.9248 19.4559C14.9248 21.3609 16.4698 22.9059 18.3748 22.9059C19.3048 22.9059 20.1447 22.5309 20.7747 21.9309L23.5198 23.9859L20.7598 26.0559C20.1448 25.4709 19.3048 25.0959 18.3898 25.0959C16.4848 25.0959 14.9398 26.6409 14.9398 28.5459C14.9398 30.4509 16.4848 31.9959 18.3898 31.9959C20.2948 31.9959 21.8398 30.4509 21.8398 28.5459C21.8398 28.3959 21.8098 28.2459 21.7948 28.0959L25.4098 25.3959L31.3348 29.8209C31.5298 29.9709 31.7698 30.0459 32.0098 30.0459C32.3548 30.0459 32.6848 29.8959 32.9098 29.5959C33.2848 29.1009 33.1798 28.3959 32.6848 28.0209L27.2548 23.9859Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissors);
export default __webpack_public_path__ + "static/media/scissors.5e7e44b8ecdab89bb1f44937f031dfd9.svg";
export { ForwardRef as ReactComponent };